<template>
  <div class="page-card feedback-page">
    <a-form v-model:model="feedForm" layout="vertical" class="feed-form">
      <a-form-item label="问题描述" name="content" :rules="[{required:true,message:'请输入问题描述'}]">
        <a-textarea
          v-model:value="feedForm.content"
          :rows="5"
          :maxlength="200"
          show-count
          placeholder="请简要描述您所遇到的问题或者建议"
        />
      </a-form-item>

      <a-form-item label="上传图片">
        <a-upload
          list-type="picture-card"
          :max-count="3"
          :file-list="fileList"
          :before-upload="beforeUpload"
          accept="image/*"
          @remove="handleRemove"
        >
          <div v-if="fileList.length < 3">
            <plus-outlined />
            <div class="upload-text">上传</div>
          </div>
        </a-upload>
        <p class="feed-tip">支持JPG/PNG/GIF格式，单张小于2M，不超过3张</p>
      </a-form-item>

      <a-form-item>
        <a-button type="primary" :loading="submitting" @click="handleSubmit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import { PlusOutlined } from '@ant-design/icons-vue'
import { createFeedback } from '../../api/personal/feedback'

const submitting = ref(false)
const fileList = ref([])
const rawFiles = ref([])

const feedForm = reactive({
  content: ''
})

// 图片上传拦截，只做校验，不调接口
const beforeUpload = (file) => {
  const isImage = file.type.startsWith('image/')
  if (!isImage) {
    message.error('只能上传图片文件')
    return false
  }

  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error('单张图片不能超过2M')
    return false
  }

  rawFiles.value.push(file)
  fileList.value = [...fileList.value, { uid: file.uid, name: file.name, status: 'done', url: URL.createObjectURL(file) }]
  return false
}

// 移除图片
const handleRemove = (file) => {
  const index = fileList.value.findIndex((f) => f.uid === file.uid)
  if (index !== -1) {
    rawFiles.value.splice(index, 1)
    fileList.value.splice(index, 1)
  }
}

// 提交反馈：先上传图片拿到fileId，再提交
const handleSubmit = async () => {
  if (!feedForm.content.trim()) {
    message.warning('请输入问题描述')
    return
  }

  submitting.value = true
  try {
    await createFeedback(feedForm.content, rawFiles.value)
    message.success('提交成功，感谢您的反馈')
    feedForm.content = ''
    fileList.value = []
    rawFiles.value = []
  } catch (e) {
    // 错误已在拦截器中处理
  } finally {
    submitting.value = false
  }
}
</script>

<style scoped lang="less">
.page-card {
  background: #F7F8FA;
  border-radius: 0 0 12px;
  padding: 28px;
  min-height: 820px;
  border: 34px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
//   margin: 0 auto;
//   max-width: 600px;
}
.feed-form {
    background-color: #fff;
    min-width: 820px;
    //   min-height: 420px;
    padding: 24px;
}
.feed-tip {
  font-size: 13px;
  color: #8c8c8c;
  margin-top: 6px;
}
</style>